import React from "react";
import { useNavigate } from "react-router-dom";
import { TwMainLayout } from "../../components/tailwind";
import { Alert, Card, Icons, SessionPicker, TrialLayout, useTrialClub } from "./trialShared";

/**
 * /trial — the club's open schedule for newcomers ("Book a free trial class" link on the club's website).
 * Tap a class -> /trial/book/:sessionId (details + SMS code).
 */
export default function TrialSchedulePage() {
  const navigate = useNavigate();
  const { link, details } = useTrialClub();
  const [apiClub, setApiClub] = React.useState(null);
  const query = window.location.search.includes("club=") ? `?club=${encodeURIComponent(link)}` : "";

  const pick = (session) => navigate(`/trial/book/${session._id}${query}`, { state: { session, club: apiClub } });

  return (
    <TwMainLayout fullScreen={true} checkSession={false} userType="skip">
      <TrialLayout
        details={details}
        apiClub={apiClub}
        title="Try a class for free"
        subtitle={
          <div className="flex flex-wrap gap-x-4 gap-y-1.5 text-[14px]">
            {["1 free class", "No payment", "No account needed"].map((t) => (
              <span key={t} className="flex items-center gap-1.5">
                <span className="flex h-[18px] w-[18px] items-center justify-center rounded-full bg-white/20">{Icons.check("h-3 w-3")}</span>
                {t}
              </span>
            ))}
          </div>
        }
      >
        {link ? (
          <div className="pt-1">
            <SessionPicker clubLink={link} onPick={pick} onLoaded={(d) => setApiClub(d.club)} />
            <p className="mt-6 text-center text-[13px] text-gray-500">Pick a class, fill in your name and number, and we'll text you to confirm.</p>
          </div>
        ) : (
          <Card className="mt-5 p-5">
            <Alert>Open this page from your club's link to see its classes.</Alert>
          </Card>
        )}
      </TrialLayout>
    </TwMainLayout>
  );
}
